import m from "../../../../geodata/es2015/region/usa/hiHigh";
window.am4geodata_region_usa_hiHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/hiHigh.js
// module id = null
// module chunks = 